import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { inputBoxStyles } from "../InputBox/input.style";
import ErrorLabel from "../ErrorLabel";
import { WarningOutlineIcon } from "../../packages/SVGs";
import "./index.scss";
import { ValueStrings } from "../../utils/constantsString";

const DupontDatePicker = React.forwardRef(
  (
    {
      id,
      label,
      labelClass,
      className,
      disabled,
      minDate,
      maxDate,
      error,
      isRequired,
      dateFormat,
      placeholderText,
      showTimeSelect = false,
      portalId = "dupont-datepicker-portal",
      popperPlacement = "bottom-start",
      popperClassName = "dupont-datepicker-popper",
      ...props
    },
    ref
  ) => {
    const classes = inputBoxStyles();

    const handleRawChange = (event) => {
      const inputText = event.target.value;
      if (inputText) {
        const sanitizedText = inputText.replace(/[^\w\s:]/gi, ""); // Only allow alphabests numbers and colon
        event.target.value = sanitizedText;
      }
    };

    return (
      <div>
        {label && (
          <div className={labelClass}>
            {isRequired && <span style={{ color: "red" }}>*</span>} {label}
          </div>
        )}
        <DatePicker
          {...props}
          id={id}
          disabled={disabled}
          className={`${classes.textfield} custom-input ${className}`}
          minDate={minDate}
          maxDate={
            maxDate || new Date().setFullYear(new Date().getFullYear() + 1)
          }
          minTime={props.minTime || new Date(new Date().setHours(0, 0, 0, 0))}
          maxTime={
            props.maxTime || new Date(new Date().setHours(23, 59, 59, 999))
          }
          onChangeRaw={handleRawChange}
          showTimeSelect={showTimeSelect}
          dateFormat={dateFormat || ValueStrings.DATE_FORMAT_SMALL}
          placeholderText={placeholderText || ValueStrings.dateFormat}
          shouldCloseOnSelect={false}
          portalId={portalId}
          popperPlacement={popperPlacement}
          popperClassName={popperClassName}
        />

        <div className="errorText">
          {error && (
            <>
              <WarningOutlineIcon isError />
              <ErrorLabel className="text-left " message={error} />
            </>
          )}
        </div>
      </div>
    );
  }
);

export default DupontDatePicker;
